/* Alpen MOOR 1618 — product page image lightbox (V16, 2026-10-06, user choice B "click to enlarge").
   The main image stays still on hover; a click or tap on it (or on the round magnifier button) opens the
   image large over the page. Previous / next with buttons, arrow keys or a swipe; Esc, the X or a click
   outside closes it and the gallery moves to the image that was open. Styles: am-motion.css section 6.
   Also adds previous / next arrows on the main image (2026-10-06); they fade out at the first and last image. */
(function () {
  var ICON = {
    mag: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true" focusable="false"><circle cx="11" cy="11" r="6"/><path d="M20 20l-4.5-4.5M11 8v6M8 11h6"/></svg>',
    x: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    prev: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7"/></svg>',
    next: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7"/></svg>'
  };
  function init() {
    var g = document.querySelector('am-pdp-gallery');
    if (!g || g.dataset.amLb) return;
    var stage = g.querySelector('.am-pdp__stage');
    var track = g.querySelector('.am-pdp__track');
    var imgs = Array.prototype.slice.call(g.querySelectorAll('.am-pdp__slide img'));
    if (!stage || !track || !imgs.length) return;
    g.dataset.amLb = '1';
    var items = imgs.map(function (im) { return { src: im.getAttribute('src'), alt: im.getAttribute('alt') || '' }; });
    var many = items.length > 1;

    stage.classList.add('am-lb-ready');
    var zoom = document.createElement('button');
    zoom.type = 'button';
    zoom.className = 'am-pdp__zoom';
    zoom.setAttribute('aria-label', 'Enlarge image');
    zoom.innerHTML = ICON.mag;
    stage.appendChild(zoom);

    if (many) {
      var arrows = ['prev', 'next'].map(function (d) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'am-pdp__arrow am-pdp__arrow--' + d;
        b.setAttribute('aria-label', d === 'prev' ? 'Previous image' : 'Next image');
        b.innerHTML = ICON[d];
        stage.appendChild(b);
        return b;
      });
      var goTo = function (n) {
        n = Math.max(0, Math.min(items.length - 1, n));
        if (typeof g.go === 'function') g.go(n); else track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
      };
      var sync = function () {
        var c = Math.round(track.scrollLeft / (track.clientWidth || 1));
        arrows[0].disabled = c <= 0;
        arrows[1].disabled = c >= items.length - 1;
      };
      arrows[0].addEventListener('click', function () { goTo(Math.round(track.scrollLeft / (track.clientWidth || 1)) - 1); });
      arrows[1].addEventListener('click', function () { goTo(Math.round(track.scrollLeft / (track.clientWidth || 1)) + 1); });
      track.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }

    var lb = document.createElement('div');
    lb.className = 'am-lb';
    lb.hidden = true;
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Product images');
    lb.innerHTML = '<img class="am-lb__img" alt="">' +
      '<button type="button" class="am-lb__btn am-lb__close" aria-label="Close">' + ICON.x + '</button>' +
      (many ? '<button type="button" class="am-lb__btn am-lb__prev" aria-label="Previous image">' + ICON.prev + '</button>' +
        '<button type="button" class="am-lb__btn am-lb__next" aria-label="Next image">' + ICON.next + '</button>' +
        '<p class="am-lb__count" aria-live="polite"></p>' : '');
    document.body.appendChild(lb);
    var big = lb.querySelector('.am-lb__img');
    var closeBtn = lb.querySelector('.am-lb__close');
    var count = lb.querySelector('.am-lb__count');
    var btns = Array.prototype.slice.call(lb.querySelectorAll('button'));
    var i = 0, last = null, timer = null;

    function current() { return Math.round(track.scrollLeft / (track.clientWidth || 1)); }
    function show(n) {
      i = (n + items.length) % items.length;
      big.src = items[i].src;
      big.alt = items[i].alt;
      if (count) count.textContent = (i + 1) + ' / ' + items.length;
    }
    function open() {
      clearTimeout(timer);
      last = document.activeElement;
      show(current());
      lb.hidden = false;
      document.documentElement.classList.add('am-lb-lock');
      void lb.offsetWidth; // apply the closed state first so the 0.4s fade runs
      lb.classList.add('is-open');
      closeBtn.focus();
    }
    function close() {
      lb.classList.remove('is-open');
      document.documentElement.classList.remove('am-lb-lock');
      timer = setTimeout(function () { lb.hidden = true; }, 400);
      if (i !== current() && typeof g.go === 'function') g.go(i);
      if (last && last.focus) last.focus();
    }

    track.addEventListener('click', function (e) { if (e.target.closest('img')) open(); });
    track.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); open(); } });
    zoom.addEventListener('click', open);
    closeBtn.addEventListener('click', close);
    if (many) {
      lb.querySelector('.am-lb__prev').addEventListener('click', function () { show(i - 1); });
      lb.querySelector('.am-lb__next').addEventListener('click', function () { show(i + 1); });
    }
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden || !lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (many && e.key === 'ArrowLeft') show(i - 1);
      else if (many && e.key === 'ArrowRight') show(i + 1);
      else if (e.key === 'Tab') {
        var k = btns.indexOf(document.activeElement);
        e.preventDefault();
        btns[(k + (e.shiftKey ? -1 : 1) + btns.length) % btns.length].focus();
      }
    });
    var x0 = null;
    lb.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (x0 === null || !many) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
